<!-- 页面首页 -->
<template>
	<div id="home">
		<header-top></header-top>

		<div id="contentBox">
			<div class="left">
				<left-top></left-top>
				<left-center></left-center>
				<left-bottom></left-bottom>
			</div>
			<div class="center">
				<center-top></center-top>
				<center-center></center-center>
				<center-bottom></center-bottom>
			</div>
			<div class="right">
				<right-top></right-top>
				<right-center></right-center>
				<right-bottom></right-bottom>
			</div>
		</div>
	</div>
</template>

<script>
	// 头部标题
	import headerTop from "../components/header/index.vue"
	// 左边第一个
	import leftTop from "../components/leftTop/index.vue"
	// 左边第二个
	import leftCenter from "../components/leftCenter/index.vue"
	// 左边第三个
	import leftBottom from "../components/leftBottom/index.vue"
	// 中间第一个
	import centerTop from "../components/centerTop/index.vue"
	// 中间第二个
	import centerCenter from "../components/centerCenter/index.vue"
	// 中间第三个
	import centerBottom from "../components/centerBottom/index.vue"
	// 右边第一个
	import rightTop from "../components/rightTop/index.vue"
	// 右边第二个
	import rightCenter from "../components/rightCenter/index.vue"
	// 右边第三个
	import rightBottom from "../components/rightBottom/index.vue"
	import {
		apiurl,
		imgurl
	} from '@/common/js/baseApi';

	export default {
		components: {
			headerTop,
			leftTop,
			leftCenter,
			leftBottom,
			centerTop,
			centerCenter,
			centerBottom,
			rightTop,
			rightCenter,
			rightBottom
		},

		data() {
			return {}
		},
		computed: {},
		watch: {},
		methods: {},
		created() {},
		mounted() {},
		beforeCreate() {},
		beforeMount() {},
		beforeUpdate() {},
		updated() {},
		beforeDestroy() {},
		destroyed() {},
		activated() {},
	}
</script>
<style scoped lang="scss">
	#home {
		width: 120rem;
		height: 67.5rem;
		background: url(../common/img/bg.png) 0 0 no-repeat;
		background-size: 100% 100%;

		#contentBox {
			width: 120rem;
			height: 60rem;
			box-sizing: border-box;
			padding: 0 1.75rem 1.75rem;
			display: flex;
			align-items: center;
			justify-content: space-between;

			.left {
				width: 33.5rem;
				height: 100%;
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: space-between;
			}

			.center {
				width: 50.5625rem;
				height: 100%;
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: space-between;
			}

			.right {
				width: 27.1875rem;
				height: 100%;
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: space-between;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/view/Home.vue